"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutPropertiesLoose2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutPropertiesLoose"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inheritsLoose2 = _interopRequireDefault(require("@babel/runtime/helpers/inheritsLoose"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _styles = _interopRequireDefault(require("../styles"));

var _Switch = _interopRequireDefault(require("@material-ui/core/Switch"));

var _classnames = _interopRequireDefault(require("classnames"));

var _tokens = require("../styles/tokens");

var _excluded = ["classes", "checked", "disabled"];

var styles = function styles(theme) {
  return {
    root: {
      width: '3.75rem',
      height: '3rem',
      padding: '0.9375rem 0.5rem 0.75rem 0.75rem'
    },
    switchBase: {
      '&$checked': {
        color: theme.palette.grey[100],
        '& + $barBase': {
          opacity: 1,
          backgroundColor: theme.palette.ctaColor.base,
          border: 'none'
        },
        '& $iconBase': {
          boxShadow: 'none',
          border: 'none !important'
        },
        '&:hover': {
          backgroundColor: 'transparent'
        }
      },
      '&:hover': {
        backgroundColor: 'transparent'
      },
      top: '8px',
      left: '5px'
    },
    checked: {
      display: 'block'
    },
    barBase: {
      borderRadius: '0.75rem',
      width: _tokens.sizingXLarge,
      height: '1.25rem',
      backgroundColor: theme.palette.grey[100],
      opacity: 1,
      transition: 'none'
    },
    bar: {
      '& + $barBase': {
        border: _tokens.borderWidthThick + " solid " + theme.palette.grey[400]
      }
    },
    barFocused: {
      '& + $barBase': {
        border: _tokens.borderWidthThick + " solid " + theme.palette.grey[400],
        boxShadow: _tokens.boxShadowFocus
      },
      '&$checked': {
        '& + $barBase': {
          boxShadow: _tokens.boxShadowFocus
        }
      }
    },
    disabledOff: {
      '& + $barBase': {
        opacity: 1,
        backgroundColor: theme.palette.grey[300]
      },
      '&$switchBase': {
        color: theme.palette.grey[300],
        //disabled off circle
        boxShadow: 'none',
        '& + $barBase': {
          opacity: 1,
          backgroundColor: theme.palette.grey[300],
          //disabled off background
          border: _tokens.borderWidthThick + " solid " + theme.palette.grey[400] //disabled off border

        }
      }
    },
    disabledOn: {
      '& + $barBase': {
        opacity: 1,
        backgroundColor: theme.palette.grey[300]
      },
      '&$switchBase': {
        color: theme.palette.grey[300],
        //disabled on circle
        boxShadow: 'none',
        '& + $barBase': {
          opacity: 1,
          backgroundColor: theme.palette.grey[400],
          //disabled on background
          border: _tokens.borderWidthThick + " solid " + theme.palette.grey[400] //disabled on border

        }
      }
    },
    iconBase: {
      width: _tokens.sizingSmall,
      height: _tokens.sizingSmall
    },
    iconOn: {
      boxShadow: 'none',
      border: 'none !important'
    },
    iconOnDisabled: {
      boxShadow: 'none',
      border: 'none !important',
      color: theme.palette.grey[300]
    },
    iconOff: {
      color: theme.palette.grey[100],
      border: _tokens.borderWidthThin + " solid " + theme.palette.grey[400],
      boxShadow: 'none !important' //MUI applies a very stubborn box-shadow when a border is added

    },
    iconOffDisabled: {
      border: _tokens.borderWidthThin + " solid " + theme.palette.grey[400],
      boxShadow: 'none !important' //MUI applies a very stubborn box-shadow when a border is added

    }
  };
};
/**
 * Use `Switch` to select one of two options, typically a "yes/no" or an "on/off" selection.
 * @done true
 * @updated v4.1.0
 * @versionAdded v0.0.8
 * @examples
 *  SwitchExamples
 *  ControlledExample
 *  SwitchFormGroup
 *  SwitchLabels
 */


var Switch = /*#__PURE__*/function (_React$Component) {
  (0, _inheritsLoose2.default)(Switch, _React$Component);

  function Switch(props) {
    var _this;

    _this = _React$Component.call(this, props) || this;
    _this.state = {
      isFocused: false
    };
    _this.handleFocus = _this.handleFocus.bind((0, _assertThisInitialized2.default)(_this));
    _this.handleBlur = _this.handleBlur.bind((0, _assertThisInitialized2.default)(_this));
    return _this;
  }

  var _proto = Switch.prototype;

  _proto.handleFocus = function handleFocus(e) {
    if (this.props.onFocus) {
      this.props.onFocus(e);
    }

    this.setState(function (prevState) {
      return {
        isFocused: true
      };
    });
  };

  _proto.handleBlur = function handleBlur(e) {
    if (this.props.onBlur) {
      this.props.onBlur(e);
    }

    this.setState(function (prevState) {
      return {
        isFocused: false
      };
    });
  };

  _proto.render = function render() {
    var isFocused = this.state.isFocused;
    var _this$props = this.props,
        classes = _this$props.classes,
        checked = _this$props.checked,
        disabled = _this$props.disabled,
        rest = (0, _objectWithoutPropertiesLoose2.default)(_this$props, _excluded);
    var classOverrides = {
      switchBase: (0, _classnames.default)(classes.switchBase, isFocused ? classes.barFocused : classes.bar),
      track: classes.barBase,
      root: classes.root,
      disabled: checked ? classes.disabledOn : classes.disabledOff,
      thumb: (0, _classnames.default)(classes.iconBase, disabled ? classes.iconOffDisabled : classes.iconOff),
      checked: classes.checked
    };
    return /*#__PURE__*/_react.default.createElement(_Switch.default, (0, _extends2.default)({
      onFocus: this.handleFocus,
      onBlur: this.handleBlur,
      color: "secondary",
      disableRipple: true,
      classes: classOverrides,
      checked: checked,
      disabled: disabled
    }, rest));
  };

  return Switch;
}(_react.default.Component);

Switch.muiName = 'Switch';
Switch.displayName = 'Switch';
Switch.propTypes = {
  /**
   * If `true`, the component is checked.
   */
  checked: _propTypes.default.bool,

  /**
   * Override or extend the styles applied to the component.
   */
  classes: _propTypes.default.object,

  /**
   * If true, the switch will be disabled.
   */
  disabled: _propTypes.default.bool,

  /**
   * The id of the input element.
   */
  id: _propTypes.default.string,

  /**
   * Attributes applied to the input element.
   */
  inputProps: _propTypes.default.object,

  /**
   * Use this property to pass a ref callback to the native input component.
   */
  inputRef: _propTypes.default.oneOfType([_propTypes.default.func, _propTypes.default.object]),

  /**
   * Callback fired when the state is changed.
   */
  onChange: _propTypes.default.func,

  /**
   * @ignore
   */
  onBlur: _propTypes.default.func,

  /**
   * @ignore
   */
  onFocus: _propTypes.default.func
};

var _default = (0, _styles.default)(styles)(Switch);

exports.default = _default;